import { render, staticRenderFns } from "./GoodsForm.vue?vue&type=template&id=548fbfb9&"
import script from "./GoodsForm.vue?vue&type=script&lang=js&"
export * from "./GoodsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports